/// analytic/eventos

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { BaseRequestResponse } from '@/_types/services';
import { handleResponseThrowError } from '@/_utils/services';
import { GET_ANALYTCS_EVENTS } from '../constants';

const getAnalyticsEvents = () => {
  return apiClient
    .get<BaseRequestResponse<string[]>>(`/analytic/eventos`)
    .then(response => response.data.data)
    .catch(handleResponseThrowError());
};

type GetAnalyticsEvents = Awaited<ReturnType<typeof getAnalyticsEvents>>;

export const useGetAnalyticsEvents = (
  options: Omit<
    UseQueryOptions<GetAnalyticsEvents, unknown, GetAnalyticsEvents, string[]>,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_ANALYTCS_EVENTS],
    queryFn: () => getAnalyticsEvents(),
    ...options,
  });
};
